import LayoutBasic from '../../layouts/layoutBasic'
import { withRouter } from 'next/router'
import axios from 'axios'
import {TOKEN, GET_EVENT_PHOTOS, EVENT_PHOTOS_URL, GET_USER_URL} from '../../vars'
import {getLocalKeyValue} from '../../storage'
import {GET} from '../../helpers'
import Pagination, {EventPhotosPagination} from '../../components/pagination'
import ProgressiveImage from 'react-progressive-image'
import LazyLoad from 'react-lazyload';

class Events extends React.Component {

  static async getInitialProps(props) {
    let token = await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token
    let event_name = props.query.event_name
    let infoRequest, infoResponse={}

    try {
      const res = await axios(GET_EVENT_PHOTOS+'?event_name='+event_name+'&page='+(props.query.page ? props.query.page:1))
      const data = await res.data

      if(token) {
        try {
          infoRequest = await GET(GET_USER_URL, token)
          infoResponse = await infoRequest.data
        } catch (e) {

        }
      }

      return {
        cart: infoResponse.cart,
        token: token,
        user: infoResponse.user,
        event_name:event_name,
        photos: data.results,
        total_pages:data.total_pages,
        next_page: data.next_page,
        previous_page:data.previous_page,
        current_page:data.page,
        total_pages: data.total_pages,
      }

    } catch (e) {

      if(token) {
        try {
          infoRequest = await GET(GET_USER_URL, token)
          infoResponse = await infoRequest.data
        } catch (e) {

        }
      }
      return {
        cart: infoResponse.cart,
        token: token,
        user: infoResponse.user,
      }

    }
  }
  render (){
    let props = this.props
    let browser_title = props.event_name?props.event_name:"Not Found" + " - Picxy Events " + "page " +props.current_page
    let photos
    if (props.photos) {
      photos = props.photos.map((photo,id) =>{
        let photo_src = EVENT_PHOTOS_URL + photo.attachment
        let content = <LazyLoad key={photo.id} once>
            <ProgressiveImage src={photo_src} key={photo.id} placeholder="../../static/img/favicon.png">
              {src=><img className="event-img img-fluid rounded-lg" src={photo_src} alt={props.title} />}
            </ProgressiveImage>
          </LazyLoad>
        let className = "col-md-4 mb-4"
        return <div className= {className} key={photo.id}>
              {content}
        </div>
      })
    }
    else{
      photos = <div className="col text-center">No event found!</div>
    }

    let pagination
    if(photos && photos.length) {
      pagination = <EventPhotosPagination event_name={props.event_name} {...props} />
    }
    let event_title = props.event_name ? "91springboard Kondapur Hub Launch" : ""
    return <LayoutBasic title={browser_title} {...props} defaultNavBar={true}>
      <div className="container font-small mt-5">
        <div className="text-center mb-5">
          <h1 className="mb-3">{event_title}</h1>
        </div>
        <div className="row">
          {photos}
        </div>
        <div className="row ">
            <div className="col text-sm-end">
              {pagination}
            </div>
        </div>
      </div>
    </LayoutBasic>
  }
}

export default withRouter(Events)
